// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"624": "6139fa82","66": "1f5be57b","714": "77df5260","739": "6887bdf0","797": "252acbb8",}[chunkId] + ".js"
}